import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromUser from './user.reducer';
import { UserState } from './user.state';
import { User, GroupMember } from '@era/security-sdk';
import { selectCurrentUserId, selectCurrentGroupId } from '../router/security-router.selector';
import { selectCurrentGroupUsers } from '../member-user/member-user.selector';

export const selectUserState = createFeatureSelector<UserState>('users');

export const selectUserIds = createSelector(selectUserState, fromUser.selectUserIds);

export const selectAllUsers = createSelector(selectUserState, fromUser.selectAllUsers);

export const selectCurrentUser = createSelector(selectCurrentUserId, selectAllUsers, (userId, users) => {
  const user = users.find((x) => x.id === userId);
  return user ? user : undefined;
});

export const selectUserNameFromId = (id: string) =>
  createSelector(selectAllUsers, (allUsers: User[]) => {
    if (allUsers && id) {
      const user = allUsers.find((x) => x.id === id);
      return user ? user.displayName : undefined;
    }
    return undefined;
  });

export const selectAllPossibleUsers = createSelector(
  selectAllUsers,
  selectCurrentGroupUsers,
  selectCurrentGroupId,
  (allUsers: User[], currentUsers: GroupMember[], currentGroupId: string) =>
    allUsers && currentUsers && currentGroupId
      ? allUsers.filter((user) =>
          currentUsers.every((currentUser) => user.id !== currentUser.id && currentUser.parentId === currentGroupId)
        )
      : undefined
);

export const selectUsersLoaded = createSelector(selectAllUsers, (users: User[]) => users && users.length > 0);
